export const TODAY_AND_N_DAYS = 'today+n';
export const TODAY_AND_N_WEEKDAYS = 'today+n_wd';
export const CUSTOM_SCHEDULER_LINK = 'schedulerlink';
export const NON_SFDC_FIELDS = {
  label: 'Custom Merge Fields',
  options: [
    {
      name: 'today',
      label: 'Today',
    },
    {
      name: 'tomorrow',
      label: 'Tomorrow',
    },
    {
      name: TODAY_AND_N_DAYS,
      label: 'Today + x number of days',
    },
    {
      name: TODAY_AND_N_WEEKDAYS,
      label: 'Today + x number of weekdays',
    },
    {
      name: 'schedulerlink',
      label: 'Custom scheduler link',
    },
  ],
};
